<template>
    <div>
        <div class="modal hide fade" id="modalSaleOrderDealForm" tabindex="-1" role="dialog" aria-labelledby="modalSaleOrder" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Invoice {{ sales.company_no }}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group row">
                                    <label for="order_no" class="col-sm-3 col-form-label text-left">Order No.</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="sales.order_no" class="form-control" disabled="disabled"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="sale_date" class="col-sm-3 col-form-label text-left">Date</label>
                                    <div class="col-sm-9">
                                        <datetime v-model="sales.sale_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" :disabled="sales.lock"></datetime>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="term_due_id" class="col-sm-3 col-form-label text-left">Term Due Date <span style="color: red;">*</span></label>
                                    <div class="col-sm-9">
                                    <select v-model="sales.term_due_id" class="form-control">
                                        <option v-for="t in termDueList" :key="t.id" :value="t.id">{{ t.name }}</option>
                                        <option value=""><i>Custom</i></option>
                                    </select>
                                    </div>
                                </div>
                                <div class="form-group row" v-if="sales.term_due_id === '' || sales.term_due_id === null">
                                    <label for="sale_due_date" class="col-sm-3 col-form-label text-left">Due Date</label>
                                    <div class="col-sm-9">
                                        <datetime v-model="sales.sale_due_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" :disabled="sales.lock"></datetime>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="type_id" class="col-sm-3 col-form-label text-left">Type</label>
                                    <div class="col-sm-9">
                                        <select class="form-control" v-model="sales.type_id" >
                                            <option v-for="t in salesTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="salesman_id" class="col-sm-3 col-form-label text-left">Sales Person</label>
                                    <div class="col-sm-9">
                                        <select class="form-control" v-model="sales.salesman_id" disabled="disabled">
                                            <option v-for="u in employeeList" :key="u.id" :value="u.employee_no">{{ u.employee_no }} - {{ u.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group row">
                                    <label for="customer_no" class="col-sm-3 col-form-label text-left">Customer No</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="sales.customer_no" disabled="disabled"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="sales.customer.name" disabled="disabled"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="sales.customer.phone" disabled="disabled"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                                    <div class="col-sm-9">
                                        <textarea class="form-control" rows="3" v-model="sales.customer.address" disabled="disabled"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group row">
                                    <label for="tax_id" class="col-sm-3 col-form-label text-left">Tax</label>
                                    <div class="col-sm-9">
                                        <select v-model="sales.tax_id" class="btn btn-outline-primary btn-sm" disabled="disabled">
                                            <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="price_id" class="col-sm-3 col-form-label text-left">Price List</label>
                                    <div class="col-sm-9">
                                        <select v-model="sales.price_id" class="btn btn-outline-primary btn-sm" disabled="disabled">
                                            <option value="">-- Price List --</option>
                                            <option v-for="p in priceListGroup" :key="p.id" :value="p.id">{{ p.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-sm table-item table-striped">
                                        <thead>
                                            <th style="width: 10%">Product</th>
                                            <th style="width: 10%">Description</th>
                                            <th style="width: 10%">Warehouse</th>
                                            <th style="width: 10%">Qty</th>
                                            <th style="width: 10%">Uom</th>
                                            <th style="widht: 10%" class="text-right">Price</th>
                                            <th style="widht: 10%" class="text-right">Discount /item</th>
                                            <th style="widht: 10%" class="text-right">Tax /item</th>
                                            <th style="widht: 10%" class="text-right">Total</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(d, index) in sales.details" :key="d.id">
                                                <td><b>{{ d.product_no }}</b></td>
                                                <td>{{ d.description }}</td>
                                                <td>
                                                    <select v-model="d.warehouse_no" class="btn btn-outline-primary btn-sm">
                                                        <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.name }}</option>
                                                    </select>
                                                </td>
                                                <td><input type="text" class="form-control" v-model="d.qty" v-on:keyup="calcRow(index)"/></td>
                                                <td>
                                                    <select v-model="d.uom_id" class="form-control" @change="uomRow(index)">
                                                        <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                                                    </select>
                                                </td>
                                                <td><input type="text" class="form-control form-control-right" v-model="d.price" v-money="money" v-on:keyup="calcRow(index)"/></td>
                                                <td><input type="text" class="form-control form-control-right" v-model="d.discount" v-money="money" v-on:keyup="calcRow(index)"/></td>
                                                <td class="text-right form-table-label">{{ d.tax | currency }}</td>
                                                <td class="text-right form-table-label">{{ d.total | currency }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td class="text-right"><i>{{ getTotalPrice | currency }}</i></td>
                                                <td class="text-right"><i>{{ getTotalDiscount | currency }}</i></td>
                                                <td class="text-right"><i>{{ getTotalTax | currency }}</i></td>
                                                <td class="text-right"><i>{{ getTotalDetail | currency }}</i></td>
                                            </tr>
                                            <tr>
                                                <td colspan="8" class="text-right"><b>Sub Total</b></td>
                                                <td class="text-right">{{ getSubtotal | currency }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="8" class="text-right"><b>Discount</b></td>
                                                <td class="text-right"><input type="text" class="form-control form-control-right" v-model="sales.discount" v-money="money"/></td>
                                            </tr>
                                            <tr>
                                                <td colspan="8" class="text-right"><b>Tax</b></td>
                                                <td class="text-right"><input type="text" class="form-control form-control-right" v-model="sales.tax" v-money="money" disabled="disabled"></td>
                                            </tr>
                                            <tr>
                                                <td colspan="8" class="text-right"><b>Total</b></td>
                                                <td><input type="text" class="form-control form-control-right" v-model="sales.total" v-money="money" disabled="disabled"/></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ sales }}</pre> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click="process">Process</button>
                    </div>
                    <pre>{{ sales }}</pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SaleOrderDealFormModal',
  props: ['sales'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      termDueList: state => state.termduedates.termDueList,
      salesTypeList: state => state.sales.salesTypeList,
      employeeList: state => state.employees.employeeList,
      taxList: state => state.taxes.taxList,
      priceListGroup: state => state.priceLists.priceListGroup,
      warehouseList: state => state.warehouses.warehouseList
    }),
    getTotalPrice () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getTotalDiscount () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount.replace(/\./g, ''))
      }
      return sum
    },
    getTotalTax () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    getTotalDetail () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    getSubtotal: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].price !== '0') {
          sum += parseFloat(array[i].price.replace(/\./g, '')) * parseFloat(array[i].qty)
        }
      }
      return sum
    }
  },
  methods: {
    process () {
      this.$emit('processSales', this.sales)
    },
    setWarehouseDetail () {
      var warehouse = this.sales.warehouse_no
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        array[i].warehouse_no = warehouse
      }
    },
    uomRow (index) {
      var detail = this.sales.details[index]
      detail.price = 0
      detail.qty = 0
      detail.dicount = 0
      detail.tax = 0
      detail.total = 0
      var uom = detail.uomList.find(d => d.id === detail.uom_id)
      console.log(uom)
      var price = 0
      if (uom.category_id === 3) {
        price = parseFloat(uom.price)
      } else if (uom.category_id === 1) {
        price = parseFloat(uom.price) * parseFloat(uom.ratio)
      } else {
        price = parseFloat(uom.price) / parseFloat(uom.ratio)
      }
      detail.price = price.toString()
    },
    setTotalDiscount: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        // sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
        sum += parseFloat(array[i].discount.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    setTotalTax () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        console.log('tax detail: ' + array[i].tax)
        // sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
        if (isNaN(array[i].tax)) {
          sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
        } else {
          sum += array[i].tax * parseInt(array[i].qty)
        }
      }
      return sum.toString()
    },
    calcRow (index) {
      // initialize
      var detail = this.sales.details[index]
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      var total = 0
      // detail
      var qty = detail.qty
      var price = detail.price.replace(/\./g, '')
      var discount = detail.discount.replace(/\./g, '')
      var dpp = price - discount
      // tax
      if (tax.include) {
        detail.tax = 0
        total = qty * dpp
      } else {
        detail.tax = dpp * parseFloat(tax.amount) / 100
        total = (dpp + detail.tax) * qty
      }
      detail.total = total.toString()
      this.sales.discount = this.setTotalDiscount()
      this.sales.tax = this.setTotalTax()
      var totalSales = parseFloat(this.getSubtotal) - parseFloat(this.sales.discount.replace(/\./g, '')) + parseFloat(this.sales.tax)
      this.sales.total = totalSales.toString()
    }
  }
}
</script>
